import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { CheckCircle, XCircle } from 'lucide-react';
import { toast } from 'sonner';

const PendingAdmins = () => {
  const [pendingAdmins, setPendingAdmins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPendingAdmins();
  }, []);

  const fetchPendingAdmins = async () => {
    try {
      const response = await axios.get(`${API}/admins/pending`);
      setPendingAdmins(response.data);
    } catch (error) {
      console.error('Error fetching pending admins:', error);
      toast.error('Error al cargar solicitudes');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (adminId) => {
    try {
      await axios.post(`${API}/admins/${adminId}/approve`);
      toast.success('Administrador aprobado');
      fetchPendingAdmins();
    } catch (error) {
      console.error('Error approving admin:', error);
      toast.error('Error al aprobar');
    }
  };

  const handleReject = async (adminId) => {
    try {
      await axios.post(`${API}/admins/${adminId}/reject`);
      toast.success('Solicitud rechazada');
      fetchPendingAdmins();
    } catch (error) {
      console.error('Error rejecting admin:', error);
      toast.error('Error al rechazar');
    }
  };

  if (loading) {
    return <div className="text-center py-12">Cargando...</div>;
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-3xl" data-testid="pending-admins-title">
            Administradores Pendientes de Aprobación
          </CardTitle>
        </CardHeader>
        <CardContent>
          {pendingAdmins.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              No hay solicitudes pendientes
            </div>
          ) : (
            <div className="space-y-4">
              {pendingAdmins.map((admin) => (
                <Card key={admin.id} className="border-2">
                  <CardContent className="p-6">
                    <div className="flex items-center justify-between">
                      <div className="space-y-1">
                        <h3 className="text-lg font-semibold">{admin.name}</h3>
                        <p className="text-gray-600">{admin.email}</p>
                        <Badge variant="secondary">Pendiente</Badge>
                      </div>
                      <div className="flex gap-2">
                        <Button
                          onClick={() => handleApprove(admin.id)}
                          className="bg-green-600 hover:bg-green-700"
                          data-testid={`approve-admin-${admin.id}`}
                        >
                          <CheckCircle className="mr-2" size={18} />
                          Aprobar
                        </Button>
                        <Button
                          onClick={() => handleReject(admin.id)}
                          variant="destructive"
                          data-testid={`reject-admin-${admin.id}`}
                        >
                          <XCircle className="mr-2" size={18} />
                          Rechazar
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default PendingAdmins;
